import React from 'react'
import {Link} from "@mui/material";

const PrivateLogoMiniBeta = (props) => {
    return (
        <Link href="/app">
            <img src="/assets/famtrail-logo-beta.svg"
                 alt="Famtrail"
                 style={props.style}
            />
        </Link>
    )
}

export default PrivateLogoMiniBeta